import HcpViewPi from "@/page-components-hcp/view-pi";

export default function HcpViewPiPage() {
  return <HcpViewPi />;
}

// Forward layout props to `_app` so it can wrap with the proper layout
HcpViewPiPage.getLayoutProps = (pageProps, router) => (
  typeof HcpViewPi.getLayoutProps === 'function'
    ? HcpViewPi.getLayoutProps(pageProps, router)
    : {}
);